import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { HTMLElementExtended } from './html-element-extended';
import { NavigationEnd, Router } from '@angular/router';

declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  trackingId: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public router: Router
  ) { }

  public appendTrackingCode(trackingId: string): void {
    try {
      if (isPlatformBrowser(this.platformId) && trackingId) {
        this.trackingId = trackingId;
        const s1: HTMLElement = document.createElement('script');
        s1.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${trackingId}');
        `;
        document.head.appendChild(s1);
        const s2: HTMLElement = document.createElement('noscript');
        const s3: HTMLIFrameElement = document.createElement('iframe');
        s3.width = '0';
        s3.height = '0';
        s3.style.display = 'none';
        s3.style.visibility = 'hidden';
        s3.src = `//www.googletagmanager.com/ns.html?id=${trackingId}`
        s2.appendChild(s3);
        (document.body as HTMLElementExtended).prepend(s2);
        this.initSubscribers();
      }
    } catch (ex) {
      console.error('Error appending google tag manager');
      console.error(ex);
    }
  }
  public addVariable(variable) {
    if (isPlatformBrowser(this.platformId) && this.trackingId) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(variable);
    }
  }
  private initSubscribers() {
    this.router.events.subscribe(event => {
      try {
          if (event instanceof NavigationEnd && this.trackingId) {
            this.addVariable({
              event:'router.NavigationEnd', 
              pageTitle: document.title,
              pagePath: event.urlAfterRedirects
            });
          }
      } catch (e) {
        console.error(e);
      }
    });
  }
}
